import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NetworkService } from "src/app/services/network.service";
import { VendorService } from "src/app/services/vendor.service";
import { ManifestService } from "src/app/services/operations/manifest.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent, IsRowSelectable } from "ag-grid-community";
import { GeoService } from "src/app/services/geo.service";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { CustomerService } from "src/app/services/customer.service";
import { ProductService } from "src/app/services/products.service";
import { AWBService } from "src/app/services/operations/awb.service";
import { NgbTypeaheadConfig } from "@ng-bootstrap/ng-bootstrap";
import { AppCoreService } from "src/app/services/app-core.service";
import Swal from "sweetalert2";
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map } from "rxjs";
import { MobileNumberValidation, regexPattern, TelephoneNumberValidation } from "src/app/models/validator";
import { Utilities } from "src/app/models/utilities";
import { Title } from "@angular/platform-browser";

interface PiecesDetails {
  piecelength: number,
  piecebreadth: number,
  pieceheight: number,
  actualweight: number,
  volumetricweight: number,
  chargeableweight: number
}
@Component({
  selector: 'app-manifestinbound',
  templateUrl: './manifestinbound.component.html',
  styleUrls: ['./manifestinbound.component.scss']

})
export class ManifestInboundComponent implements OnInit {
  manifestid: number;
  manifestForm: FormGroup;
  awbDetailsForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  manifestFormSubmitted: boolean;
  awbDetailsFormSubmitted: boolean;
  branchList: [];
  loadVendorsList: [];
  showVendors = false;
  showAwbForm = false;
  serviceCenterList: [];
  vendorList: [];
  customerList: any[];
  PaymentModeList = ['Paytm', 'GooglePay', 'Debit Card', 'Credit Card', "Net Banking"];
  productList: [];
  vendorServiceList: [] = [];
  addressBookList: any[] = [];
  unitList = [{ label: 'centimeter', value: 'cm' }, { label: 'inches', value: 'in' }];
  consigneeaddressbookid: number;
  shipperLocationInfo: any;
  consigneeLocationInfo: any;
  awbnumber: string = '';
  piecesMandate: boolean;
  piecesfldDet: any;
  numberOfRowsToGenerate: number;
  finalList: any[] = [];
  piecesDetailsList: any[] = [];
  newRow: PiecesDetails = {
    piecelength: null,
    piecebreadth: null,
    pieceheight: null,
    actualweight: null,
    volumetricweight: null,
    chargeableweight: null
  }
  currentDateTime: any;
  filteredRows!: any[];
  // prev
  
  vendorId: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  isAllGridDataLoaded = false;
  defaultColDef = {
    sortable: true,
    resizable: false,
    filter: true,
    floatingFilter: true
  };
  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    pagination: true,
    paginationPageSize: 10,
    suppressRowClickSelection: true,
    domLayout: "autoHeight"
  }
  columnDefs = [
    {
      headerName: '',
      field: 'isshipmentreceived',
      checkboxSelection: true, headerCheckboxSelection: true,
      sortable: false, filter: false, width: 30
    },
    { headerName: 'Awb no.', field: 'awbnumber' },
    { headerName: 'Booking Date', field: 'bookingdate', cellStyle: { textAlign: 'center' } },
    { headerName: 'Consignee', field: 'consigneename' },
    { headerName: 'Actual Weight', field: 'actualweight', cellStyle: { textAlign: 'end' } },
    { headerName: 'Volumetric Weight', field: 'volumetricweight', cellStyle: { textAlign: 'end' } }
  ];
  rowData: any = [];
  selectedSCId: number;
  btnMarkReceivedDisabled = true;
  minDateTime: string | number | Date;
  useEnterKey: any;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private addressbookService: AddressBookService,
    private customerService: CustomerService,
    private productService: ProductService,
    private vendorService: VendorService,
    private manifestService: ManifestService,
    private awbService: AWBService,
    private typeaheadConfig: NgbTypeaheadConfig,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private utilities: Utilities,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title
  ) {
    titleService.setTitle('Manifest');
    typeaheadConfig.selectOnExact = true;
    this.context = { componentParent: this };
  }
  
  ngOnInit(): void {
    this.minDateTime = this.utilities.FormatDateWithTime(-1).dateTimeString;
    this.currentDateTime = this.utilities.FormatDateWithTime();
    this.manifestid = this.route.snapshot.params['id'];
    this.manifestForm = this.formBuilder.group({
      ddlBranch: [],
      txtDateTime: new FormControl(this.currentDateTime.dateTimeString),
      ddlLoadVendor: [null],
      txtRemarks: [null],
      manifestFor: ['Service Center'],
      // ddlServiceCenter: [null],
      ddlVendor: [null],
    });
    this.awbDetailsForm = this.formBuilder.group({
      txtAwbNo: [null, Validators.required],
      txtAwbDate: [this.currentDateTime.dateString],
      ddlCustomer: [null, Validators.required],
      txtProduct: [null, Validators.required],
      txtVendor: [null, Validators.required],
      txtVendorService: [null, Validators.required],
      txtPieces: [],
      ddlPiecesUnit: [this.unitList[0].value],
      txtTotalActualWeight: [null],
      txtTotalVolumetricWeight: [],
      txtTotalChargeableWeight: [],
      ddlPaymentMode: [null, Validators.required],
      txtShipmentValue: [null, Validators.compose([Validators.required, Validators.pattern(regexPattern.rate)])],
      txtShipper: [null],
      txtShipperPerson: [null],
      txtShipperEmail: [null],
      txtConsignee: [null],
      txtConsigneePerson: [null],
      txtConsigneeEmail: [null],
      shipperlocationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        ddlState: [null],
        ddlCity: [null],
        txtPincode: [null],
        txtAddress1: [null, Validators.compose([Validators.required,Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
      consigneelocationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        ddlState: [null],
        ddlCity: [null],
        txtPincode: [null],
        txtAddress1: [null, Validators.compose([Validators.required,Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
    });
    this.piecesDetailsList.push(this.newRow);
    this.manifestForm.disable();
    this.manifestFormSubmitted = false;
    this.checkPermission();
    if (this.permConfig.isEditAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        // console.log('this.selectedSCId', this.selectedSCId);
      });
      // this.bindAddressBook();
      this.getAllVendors();
      // this.getServiceCenters();
      this.getManifestById();
      // this.getAwbDetailsById();
      // this.getAllCustomers();
      // this.getAllProducts();
    }
    this.awbDetailsForm.controls.txtTotalChargeableWeight.disable();
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Manifests');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  addAWBDetails() {
    if (!this.permConfig.isAddAllowed) {
      this.errAlert('No Access to Add.');
      return;
    }

    this.awbDetailsFormSubmitted = true;
    this.generateRowsOrSave();
    if (this.awbDetailsForm.invalid) {
      if (this.piecesMandate && this.awbDetailsForm.get('txtPieces')?.value <= 0) {
        this.errAlert("Please Provide Pieces Details !");
      }
      return;
    }
    this.insertIntoFinalList();
    if (this.piecesMandate && this.awbDetailsForm.get('txtPieces')?.value !== null) {
      let msg = "";
      this.piecesDetailsList.map(function (x, i) {
        if ((x.actualweight == null || x.actualweight == 0) && msg == "") {
          msg = "Actual Weight is mandatory at Box.No -" + (i + 1);
          return;
        }
      });

      if (msg) {
        this.errAlert(msg);
        return;
      }
    }

    const pieces = {
      id: null,
      piecesnumber: this.awbDetailsForm.get('txtPieces')?.value,
      pieceunit: this.awbDetailsForm.get('ddlPiecesUnit')?.value,
      actualweight: this.awbDetailsForm.get('txtTotalActualWeight')?.value,
      volumetricweight: this.awbDetailsForm.get('txtTotalVolumetricWeight')?.value,
      chargeableweight: this.awbDetailsForm.get('txtTotalChargeableWeight')?.value,
      piecesDetails: this.finalList,
    };

    let details = [];
    const shipper = this.awbDetailsForm.get('txtShipper')?.value;
    const consignee = this.awbDetailsForm.get('txtConsignee')?.value;
    let shipperArea = this.awbDetailsForm.get('shipperlocationdetails')?.get('txtArea')?.value;
    shipperArea = (typeof shipperArea === 'string') ? shipperArea : shipperArea.area;
    let consigneeArea = this.awbDetailsForm.get('consigneelocationdetails')?.get('txtArea')?.value;
    consigneeArea = (typeof consigneeArea === 'string') ? consigneeArea : consigneeArea.area;

    let shipperPincode = this.awbDetailsForm.get('shipperlocationdetails').get('txtPincode').value;
    shipperPincode = (typeof shipperPincode === 'string') ? shipperPincode : shipperPincode?.pincode;
    let consigneePincode = this.awbDetailsForm.get('shipperlocationdetails').get('txtPincode').value;
    consigneePincode = (typeof consigneePincode === 'string') ? consigneePincode : consigneePincode?.pincode;

    if (typeof shipper === 'string' || shipper instanceof String) {
      details.push({
        info: {
          type: 'Shipper',
          name: shipper,
          contactperson: this.awbDetailsForm.get('txtShipperPerson').value,
          emailid: this.awbDetailsForm.get('txtShipperEmail').value,
          status: true,
          location: {
            country: this.awbDetailsForm.get('shipperlocationdetails').get('ddlCountry')?.value,
            state: this.awbDetailsForm.get('shipperlocationdetails').get('ddlState')?.value,
            city: this.awbDetailsForm.get('shipperlocationdetails').get('ddlCity')?.value,
            pincode: shipperPincode,
            address1: this.awbDetailsForm.get('shipperlocationdetails').get('txtAddress1')?.value,
            address2: this.awbDetailsForm.get('shipperlocationdetails').get('txtAddress2')?.value,
            area: shipperArea,
            mobileno: this.awbDetailsForm.get('shipperlocationdetails').get('txtMobileNo')?.value,
            tel: this.awbDetailsForm.get('shipperlocationdetails').get('txtTelephoneNo')?.value
          }
        },
      });
    } else {
      details.push({
        info: {
          type: 'Shipper',
          id: shipper?.id,
          code: shipper?.code,
          name: shipper?.name,
          location: shipper?.location
        },
      });
    }

    if ((typeof consignee === 'string' || consignee instanceof String)) {
      details.push({
        info: {
          type: 'Consignee',
          name: consignee,
          contactperson: this.awbDetailsForm.get('txtShipperPerson').value,
          emailid: this.awbDetailsForm.get('txtShipperEmail').value,
          status: true,
          location: {
            country: this.awbDetailsForm.get('consigneelocationdetails').get('ddlCountry')?.value,
            state: this.awbDetailsForm.get('consigneelocationdetails').get('ddlState')?.value,
            city: this.awbDetailsForm.get('consigneelocationdetails').get('ddlCity')?.value,
            pincode: consigneePincode,
            address1: this.awbDetailsForm.get('consigneelocationdetails').get('txtAddress1')?.value,
            address2: this.awbDetailsForm.get('consigneelocationdetails').get('txtAddress2')?.value,
            area: this.awbDetailsForm.get('consigneelocationdetails').get('txtArea')?.value?.area,
            mobileno: this.awbDetailsForm.get('consigneelocationdetails').get('txtMobileNo')?.value,
            tel: this.awbDetailsForm.get('consigneelocationdetails').get('txtTelephoneNo')?.value
          }
        },
      });
    } else {
      details.push({
        info: {
          type: 'Consignee',
          id: consignee?.id,
          code: consignee?.code,
          name: consignee?.name,
          location: consignee?.location
        },
      });
    }
    this.awbnumber = this.awbDetailsForm.get('txtAwbNo')?.value;
    const reqObj = {
      id: null,
      awbnumber: this.awbnumber,
      bookingdate: this.awbDetailsForm.get('txtAwbDate')?.value,
      customerid: this.awbDetailsForm.get('ddlCustomer')?.value,
      consigneeaddressbookid: this.consigneeaddressbookid,
      productid: this.awbDetailsForm.get('txtProduct')?.value,
      vendorid: this.awbDetailsForm.get('txtVendor')?.value,
      serviceid: this.awbDetailsForm.get('txtVendorService')?.value,
      paymentmode: this.awbDetailsForm.get('ddlPaymentMode')?.value,
      shipmentvalue: this.awbDetailsForm.get('txtShipmentValue')?.value,
      actualweight: this.awbDetailsForm.get('txtTotalActualWeight')?.value,
      actualweightunit: this.awbDetailsForm.get('ddlPiecesUnit')?.value,
      pieces: pieces,
      details
    };
    this.awbService.AddAWB(reqObj).subscribe((res) => {
      try {
        if (res) {
          if (!res.success) {
            this.errAlert(res.message);
          }
          else {
            const rObjAwbManifest = {
              awbnumber: this.awbnumber,
              manifestid: this.manifestid
            }
            this.manifestService.AddAwb(rObjAwbManifest).subscribe((res) => {
              if (res) {
                if (!res.success) {
                  this.errAlert(res.message);
                }
                else {
                  this.openSuccessDialog("Record added successfully");
                }
              }
            });
          }
        }
      } catch (err) {
        console.error(err);
      }
    });
  }
  generateRowsOrSave() {
    if (this.awbDetailsForm.get('txtPieces')?.value > 50) {
      this.errAlert("Please Enter Pieces Upto 50");
      return;
    }
    this.numberOfRowsToGenerate = this.awbDetailsForm.get('txtPieces')?.value - this.piecesDetailsList.length;
    for (let i = 0; i < (this.numberOfRowsToGenerate); i++) {
      this.piecesDetailsList.push(this.newRow);
    }
  }

  deleteRow(index: any) {
    this.piecesDetailsList.splice(index, 1);
    this.awbDetailsForm.get('txtPieces')?.setValue(this.piecesDetailsList.length);
  }

  insertIntoFinalList() {
    const finalList: any[] = [];
    for (const item of this.piecesDetailsList) {
      if (item.actualweight !== null) {
        finalList.push(item);
      }
    }
    this.finalList = finalList;
  }

  calculateTotalWVC() {
    this.awbDetailsForm.get('txtTotalChargeableWeight')?.setValue(
      Math.max(this.awbDetailsForm.get('txtTotalActualWeight').value,
        this.awbDetailsForm.get('txtTotalVolumetricWeight').value))
  }

  calculatePiecesDetails(piecesfldDet?) {
    const division = this.awbDetailsForm.get('ddlPiecesUnit')?.value === 'in' ? 2000 : 5000;
    if (!piecesfldDet) {
      piecesfldDet = this.piecesDetailsList[0];
    }
    if (this.awbDetailsForm.get('txtPieces')?.value === null || this.awbDetailsForm.get('txtPieces')?.value <= 0) {
      return this.errAlert('Please fill number of pieces!');
    }
    let totalActualWeight = 0;
    let totalVolumetricWeight = 0;
    const actualweight: any = parseFloat(piecesfldDet.actualweight || 0);
    const lengthValue = parseFloat(piecesfldDet.piecelength || 0);
    const breadthValue = parseFloat(piecesfldDet.piecebreadth || 0);
    const heightValue = parseFloat(piecesfldDet.pieceheight || 0);
    piecesfldDet.volumetricweight = (lengthValue * breadthValue * heightValue) / division;
    piecesfldDet.chargeableweight = Math.max(piecesfldDet.volumetricweight, parseFloat(actualweight));
    for (const item of this.piecesDetailsList) {
      totalActualWeight += parseFloat(item.actualweight || 0);
      totalVolumetricWeight += parseFloat(item.volumetricweight || 0);
    }
    this.awbDetailsForm.get('txtTotalActualWeight')?.setValue(totalActualWeight);
    this.awbDetailsForm.get('txtTotalVolumetricWeight')?.setValue(totalVolumetricWeight);
    this.awbDetailsForm.get('txtTotalChargeableWeight')?.setValue(Math.max(totalActualWeight, totalVolumetricWeight));
    this.insertIntoFinalList();
  }

  async openSuccessDialog(msg) {
    const result = await Swal.fire({
      title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      this.awbDetailsForm.reset();
      this.awbDetailsFormSubmitted = false;
      this.awbDetailsForm.get('txtAwbDate')?.setValue(this.utilities.FormatDateWithTime().dateString);
      // this.getAwbDetailsById();
      this.loadDefaultsValues();
    }
  }

  getManifestById() {
    try {
      this.manifestService.GetById(this.manifestid).subscribe((res) => {
        if (res && res.data) {
          const resData = res.data[0];
          // console.log('resData', resData);
          this.manifestForm.get('txtDateTime')?.setValue(this.utilities.FormatDateWithTime(0, resData?.manifestdate).dateTimeString);
          this.manifestForm.get('ddlLoadVendor')?.setValue(resData?.loadervendorid);
          this.manifestForm.get('txtRemarks')?.setValue(resData?.remarks);
          // this.manifestForm.get('ddlServiceCenter')?.setValue(resData.servicecenterid);
          this.manifestForm.get('ddlVendor')?.setValue(resData?.thirdpartyvendorid);

          if(resData.manifestfor  === 'Service Center'){
            this.showVendors = false;
            this.manifestForm.get('manifestFor')?.setValue('Branch');
          } else {
            this.showVendors = true;
            this.manifestForm.get('manifestFor')?.setValue('Third Party');
          }
          
          if (resData.awbwise) {
            for (const item of resData.awbdetails) {
              item.bookingdate = this.utilities.formatDate(item.bookingdate).dateString;
            }
            this.rowData = [...resData?.awbdetails];

          } else {
            for (const item of resData?.bags[0]?.numbers) {
              item.bookingdate = this.utilities.formatDate(item.bookingdate).dateString;
            }
            // this.gridOptions.api.addEventListener('firstDataRendered', () => {
            //   this.filteredRows = resData?.bags[0]?.numbers.filter(item => item.isshipmentreceived);
  
            //   this.gridOptions.api.forEachNode(node => {
            //     if (this.filteredRows.some(row => row.awbnumber === node.data.awbnumber)) {
            //       node.setSelected(true);
            //     }
            //   });
            // });
            this.rowData = [...resData?.bags[0]?.numbers];
          }
        }
      })
    } catch (e) {
    }
  }

  public isRowSelectable: IsRowSelectable = (
    params: any,
  ) => {
    // console.log('params', params);
    return params.data.isshipmentreceived !== true;
  };
  
  onRowSelected(event) {
    // console.log(event);
    const selectedRows = this.gridApi.getSelectedRows();
    if (event.node.selected) {
      this.btnMarkReceivedDisabled = false;
    } else {
      if (selectedRows.length) {
        this.btnMarkReceivedDisabled = false;
      } else {
        this.btnMarkReceivedDisabled = true;
      }
    }

  }

  onMarkReceived() {
    try {
      const selectedRows = this.gridApi.getSelectedRows();
      // console.log('selectedRows', selectedRows);
      if (selectedRows.length) {
        let selectedNumbers = [];
        // from selected rows filter out rows with shipmentreceived false
        for (const a of selectedRows) {
          if (!a.isshipmentreceived) {
            selectedNumbers.push({
              awbnumber: a.awbnumber,
              parentawbnumber: a.parentawbnumber,
              isparentawb: a.awbnumber === a.parentawbnumber ? true : false
            });
          }
          
        }
        
        if (selectedNumbers.length) {
          // call update api only if there are awbnumber that are pending receive
          let requestObj = {
            type: 'manifest',
            numbers: selectedNumbers,
            manifestid: this.manifestid,
            generatedfromid: this.selectedSCId
          };
          // console.log('requestObj', requestObj);
          
          this.awbService.AwbInscan(requestObj).subscribe(res => {
              if (res && res.success) {
                this.appCoreService.showMessage('Records Sucessfully Updated');
                this.btnMarkReceivedDisabled = true;
                this.getManifestById();
              } else if (res && !res?.success) {
                this.appCoreService.showMessage('Error In Updating Record','Error','error');
              }
            });
        }

      } else {
        this.appCoreService.showMessage('No AWB selected from the list', '', 'error');
      }
    } catch(e) {
      console.error(e);
    }
  }

  async onRowFullySelected() {
    if (this.filteredRows.length == 0) {
      this.isAllGridDataLoaded = true;
    }
    // await this.onRowSelected();
    this.isAllGridDataLoaded = true;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  getAwbDetailsById() {
    try {
      this.ngxLoaderService.start();
      this.manifestService.GetAwbDetailsById(this.manifestid).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          for (const item of res.data) {
            item.bookingdate = this.utilities.formatDate(item.bookingdate).dateString;
          }
          this.rowData = res.data;
          // this.gridOptions.api.addEventListener('firstDataRendered', () => {
          //   this.filteredRows = res.data.filter(item => item.isshipmentreceived);
          //   this.gridOptions.api.forEachNode(node => {
          //     if (this.filteredRows.some(row => row.awbnumber === node.data.awbnumber)) {
          //       node.setSelected(true);
          //     }
          //   });
          // });
        }
      });
    } catch (e) {
      this.ngxLoaderService.stop();
    }
  }

  formateDate(date?: any) {
    const inputDate = date != null || undefined ? new Date(date) : new Date();
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
    const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
    const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
    const dateString = `${year}-${month}-${day}`;
    return { dateString, dateTimeString };
  }

  errAlert(msg) {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: msg,
    });
  }

  loadDefaultsValues() {
    this.manifestForm.get('txtDateTime')?.setValue(this.utilities.formatDate().dateTimeString);
    this.manifestForm.get('manifestFor')?.setValue('Service Center');
    this.awbDetailsForm.get('txtAwbDate')?.setValue(this.utilities.formatDate().dateString);
    this.awbDetailsForm.get('txtPieces')?.setValue(null);
    this.awbDetailsForm.get('ddlPiecesUnit')?.setValue(this.unitList[0].value);
    this.piecesDetailsList = [];
    this.piecesDetailsList.push(this.newRow);
    this.finalList = [];
  }

  search: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.addressBookList.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  selectedItemEventConsignee(e) {
    try {
      if (e) {
        this.bindconsigneelocationdetails(e.item);
      }
    } catch (error) {

    }
  }

  getAllCustomers() {
    try {
      this.customerService.GetAll({scid: this.appCoreService.GetUserData().selectedServiceCenter}).subscribe((res) => {
        if (res && res.success) {
          this.customerList = res.data;
        }
      })
    } catch (error) {

    }
  }

  bindshipperlocationdetails(e) {
    try {
      if (e.item) {
        const currLoc = e.item;
        this.shipperLocationInfo = {
          country: currLoc.location.country,
          state: currLoc.location.state,
          city: currLoc.location.city,
          area: currLoc.location.area,
          address1: currLoc.location.address1,
          address2: currLoc.location.address2,
          pincode: currLoc.location.pincode,
          mobileno: currLoc.location.mobileno,
          tel: currLoc.location.tel,
        };
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  bindconsigneelocationdetails(e) {
    try {
      if (e.item) {
        const currLoc = e.item;
        this.consigneeLocationInfo = {
          country: currLoc.location.country,
          state: currLoc.location.state,
          city: currLoc.location.city,
          area: currLoc.location.area,
          address1: currLoc.location.address1,
          address2: currLoc.location.address2,
          pincode: currLoc.location.pincode,
          mobileno: currLoc.location.mobileno,
          tel: currLoc.location.tel,
        };
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  bindCustomerShipperInfo() {
    const customerId = this.awbDetailsForm.get('ddlCustomer')?.value;
    const customerData: any = this.customerList.filter(x => x.id === customerId);
    const shipper = this.awbDetailsForm.get('txtShipper').value;
    if (customerData[0]?.customertype == "Co-Courier") {
      this.shipperLocationInfo = customerData.length ? (customerData[0]?.location == null ? {} : customerData[0]?.location) : {};
      const name = { name: customerData[0].name }
      this.awbDetailsForm.patchValue({
        txtShipper: name,
        txtContactPerson: customerData[0]?.contactperson,
        txtMobile: customerData[0].mobile
      });
    }
  }

  bindAddressBook() {
    try {
      this.addressbookService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.addressBookList = res.data;
        }
      });
    } catch (e) {
    }
  }

  // getServiceCenters() {
  //   try {
  //     this.networkService.GetAllServiceCenters().subscribe((res) => {
  //       if (res && res.success) {
  //         this.serviceCenterList = res.data;
  //         this.branchList = res.data;
  //       }
  //     })
  //   } catch (error) {

  //   }
  // }

  getAllVendors() {
    try {
      this.vendorService.GetAllList().subscribe((res) => {
        if (res && res.success) {
          this.vendorList = res.data;
          this.loadVendorsList = res.data.filter(item => item.vendormode === 'OBC');
        }
      })
    } catch (error) {

    }
  }

  getAllVendorServices() {
    const id = this.awbDetailsForm.get('txtVendor')?.value;
    if (id != null) {
      try {
        this.vendorService.GetAllListByVendor({ id }).subscribe((res) => {
          if (res && res.success) {
            this.vendorServiceList = res.data;
          }
        })
      } catch (error) {

      }
    }

  }

  getAllProducts() {
    try {
      this.productService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.productList = res.data;
        }
      })
    } catch (error) {

    }
  }

  onChangeProduct(e: any) {
    if (e.shipmenttype === "NDOX") {
      this.piecesMandate = true;
      this.awbDetailsForm.get('txtPieces')?.setValidators([Validators.required]);
      this.awbDetailsForm.get('ddlPiecesUnit')?.setValidators([Validators.required]);
      this.awbDetailsForm.get('txtTotalActualWeight')?.setValidators([Validators.required]);
    } else {
      this.piecesMandate = false;
      this.awbDetailsForm.get('txtPieces')?.clearValidators();
      this.awbDetailsForm.get('ddlPiecesUnit')?.clearValidators();
      this.awbDetailsForm.get('txtTotalActualWeight')?.clearValidators();
    }
    this.awbDetailsForm.get('txtPieces').updateValueAndValidity();
    this.awbDetailsForm.get('ddlPiecesUnit').updateValueAndValidity();
    this.awbDetailsForm.get('txtTotalActualWeight').updateValueAndValidity();
  }
  formatter = (x: { name: string }) => x.name;

  validateDate(): void {
    const enteredDate = new Date(this.manifestForm.get('txtDateTime')?.value);
    const minAllowedDate = new Date(this.minDateTime);

    if (isNaN(enteredDate.getTime()) || isNaN(minAllowedDate.getTime())) {
      // If either date is invalid, set an error (optional)
      this.manifestForm.get('txtDateTime')?.setErrors({ invalidDate: true });
      return;
    }

    if (enteredDate < minAllowedDate) {
      this.manifestForm.get('txtDateTime')?.setErrors({ minDate: true });
    } else {
      this.manifestForm.get('txtDateTime')?.setErrors(null);
    }
  }

}
